export interface TeamMapping {
  databaseName: string;
  displayName: string;
  filename: string;
  fileLocation: string;
}

class TeamMappingService {
  private teamMappings: Map<string, TeamMapping> = new Map();

  async initialize(): Promise<void> {
    try {
      const response = await fetch('/teamMapping.csv');
      const csvText = await response.text();
      
      const lines = csvText.split('\n');
      
      for (let i = 1; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line) {
          const values = line.split(',');
          if (values.length >= 4) {
            const databaseName = values[0].trim();
            const displayName = values[1].trim();
            const filename = values[2].trim();
            const fileLocation = values[3].trim();
            
            this.teamMappings.set(databaseName, {
              databaseName,
              displayName,
              filename,
              fileLocation
            });
          }
        }
      }
    } catch (error) {
      console.error('Error loading team mappings:', error);
    }
  }

  getDisplayName(databaseName: string): string {
    const mapping = this.teamMappings.get(databaseName);
    return mapping?.displayName || databaseName;
  }

  getLogoUrl(databaseName: string): string {
    const mapping = this.teamMappings.get(databaseName);
    if (mapping?.fileLocation) {
      return `https://cdn.redditcfb.com/60x40/${mapping.fileLocation}.png`;
    }
    
    // Fallback to old method if no mapping found
    const displayName = this.getDisplayName(databaseName);
    const filename = displayName
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/[^a-z0-9]/g, '');
    return `https://cdn.redditcfb.com/60x40/cfb/${filename}.png`;
  }

  // Keep the old method for backward compatibility
  getLogoFilename(databaseName: string): string {
    const mapping = this.teamMappings.get(databaseName);
    if (mapping?.filename) {
      return mapping.filename;
    }
    
    // Fallback to old method if no mapping found
    const displayName = this.getDisplayName(databaseName);
    return displayName
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/[^a-z0-9]/g, '');
  }
}

export const teamMappingService = new TeamMappingService();
